import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./slice/devAuthSlice";

import searchAppListReducer from './slice/search_applist_slice';
import appsDashboardReducer from './slice/apps_dashboard_slice';
import appDetailReducer from './slice/app_detail_slice';
import devAuthSlice from "./slice/devAuthSlice";
import sidenavbarSliceReducer from "./slice/side_navbar"
import appCreatedResponseSliceReducer from "./slice/app_created_response_slice/app_create_response"
import appsOverviewSliceReducer from "./slice/apps_overview_slice/apps_overview_slice"


const developerStore = configureStore({
  reducer: {
    devAuth: devAuthSlice,
    searchAppList: searchAppListReducer,
    appsDashboard: appsDashboardReducer,
    appDetail: appDetailReducer,
    sidenavbarSlice:sidenavbarSliceReducer,
    appCreatedResponse: appCreatedResponseSliceReducer,
    appsOverviewSlice:appsOverviewSliceReducer
  },
});

export default developerStore;
